import React from 'react';
import { ScholarshipSearch, PageContainer } from 'components';

const AdvancedSearchPage = ({ search }) => {
  return (
    <PageContainer>
      <ScholarshipSearch search={search} />
    </PageContainer>
  );
};

export default AdvancedSearchPage;
